(function(){
  function ready(fn){if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}
  ready(function(){
    document.querySelectorAll('.header__inline-menu a').forEach(function(a){
      try{var p=new URL(a.href).pathname.replace(/\/(en|pl|fr|de|it|pt)$/,'').replace(/\/$/,'');
        if(p===''){var li=a.closest('li'); if(li) li.style.display='none';}
      }catch(e){}
    });
    var mega=document.getElementById('mc33-mega');
    if(!mega) return;
    if(!mega.querySelector('.mc33-mega-item')){mega.remove();return;}
    if(mega.parentNode!==document.body){document.body.appendChild(mega);}
    function headerEl(){return document.querySelector('.header-wrapper')||document.querySelector('header');}
    function posDesktop(){var h=headerEl(); if(h){mega.style.top=Math.max(h.getBoundingClientRect().bottom,0)+'px';}}
    var t;
    function showDesktop(){clearTimeout(t);posDesktop();mega.classList.add('open');mega.setAttribute('aria-hidden','false');}
    function showMobile(){clearTimeout(t);mega.style.top='0px';mega.classList.add('open');mega.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden';}
    function hide(){t=setTimeout(function(){mega.classList.remove('open');mega.setAttribute('aria-hidden','true');},160);}
    function hideNow(){clearTimeout(t);mega.classList.remove('open');mega.setAttribute('aria-hidden','true');document.documentElement.style.overflow='';}
    function pickTrigger(root){if(!root)return null;var best=0,trig=null,sums=root.querySelectorAll('summary');for(var i=0;i<sums.length;i++){var d=sums[i].closest('details');if(!d)continue;var n=d.querySelectorAll('a[href*="/collections/"]').length;if(n>best){best=n;trig=sums[i];}}return trig;}
    // DESKTOP: hover/click Categorias in inline menu
    var dtrig=pickTrigger(document.querySelector('.header__inline-menu'));
    if(dtrig){
      var host=dtrig.closest('details')||dtrig.parentElement;
      host.classList.add('mc33-hide-native');
      host.addEventListener('mouseenter',function(){if(window.innerWidth>=990)showDesktop();});
      host.addEventListener('mouseover',function(){if(window.innerWidth>=990)showDesktop();});
      host.addEventListener('mouseleave',function(){if(window.innerWidth>=990)hide();});
      mega.addEventListener('mouseenter',function(){if(window.innerWidth>=990)clearTimeout(t);});
      mega.addEventListener('mouseleave',function(){if(window.innerWidth>=990)hide();});
      dtrig.addEventListener('click',function(e){if(window.innerWidth<990)return;e.preventDefault();e.stopPropagation();if(mega.classList.contains('open')){hideNow();}else{showDesktop();}});
    }
    // MOBILE: hamburger opens MY full-screen menu (bypass Dawn drawer)
    var burger=document.querySelector('.header__icon--menu');
    if(burger){
      burger.addEventListener('click',function(e){if(window.innerWidth>=990)return;e.preventDefault();e.stopPropagation();if(mega.classList.contains('open')){hideNow();}else{showMobile();}},true);
    }
    var cb=mega.querySelector('.mc33-mega-close');
    if(cb) cb.addEventListener('click',hideNow);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')hideNow();});
    document.addEventListener('click',function(e){if(window.innerWidth>=990 && mega.classList.contains('open') && !mega.contains(e.target)){var dh=dtrig?dtrig.closest('details'):null;if(!dh||!dh.contains(e.target))hideNow();}});
    window.addEventListener('scroll',function(){if(window.innerWidth>=990 && mega.classList.contains('open'))posDesktop();},{passive:true});
  });
})();
